// extracted by mini-css-extract-plugin
module.exports = {"layout":"WelcomeScreenLayout__layout__1KmId","col":"WelcomeScreenLayout__col__1j989"};